import * as React from 'react';

function PlayIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.027 45c-.803 0-1.573-.359-2.14-.998C.319 43.364 0 42.497 0 41.594V3.407c0-.581.132-1.153.384-1.66A3.267 3.267 0 011.438.506c.44-.305.942-.479 1.458-.504a2.748 2.748 0 011.491.36l33.944 19.102c.502.283.923.718 1.218 1.256.295.537.451 1.156.451 1.788 0 .631-.156 1.25-.45 1.788a3.194 3.194 0 01-1.22 1.256L4.388 44.638a2.742 2.742 0 01-1.36.362zm0-41.692l-.102.099v38.187l.146.099 33.944-19.069a.109.109 0 000-.099L3.027 3.308z"
        fill="#fff"
      />
    </svg>
  );
}

export default PlayIcon;
